import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, AlertTriangle, Info, TrendingUp } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface ErrorMetrics {
  totalErrors: number;
  criticalErrors: number;
  warnings: number;
  infoLogs: number;
  trend: 'up' | 'down' | 'stable';
}

interface ErrorMetricsCardsProps {
  logs: any[];
}

export function ErrorMetricsCards({ logs }: ErrorMetricsCardsProps) {
  const metrics: ErrorMetrics = {
    totalErrors: logs.filter(l => l.error_severity === 'ERROR' || l.error_severity === 'FATAL' || l.error_severity === 'PANIC').length,
    criticalErrors: logs.filter(l => l.error_severity === 'FATAL' || l.error_severity === 'PANIC').length,
    warnings: logs.filter(l => l.error_severity === 'WARNING').length,
    infoLogs: logs.filter(l => l.error_severity === 'LOG' || l.error_severity === 'INFO').length,
    trend: 'stable',
  };

  return (
    <div className="grid gap-4 md:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Errors</CardTitle>
          <AlertCircle className="h-4 w-4 text-destructive" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{metrics.totalErrors}</div>
          <p className="text-xs text-muted-foreground">Last 100 logs</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Critical Errors</CardTitle>
          <AlertCircle className="h-4 w-4 text-destructive" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-destructive">{metrics.criticalErrors}</div>
          <p className="text-xs text-muted-foreground">FATAL/PANIC level</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Warnings</CardTitle>
          <AlertTriangle className="h-4 w-4 text-warning" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-warning">{metrics.warnings}</div>
          <p className="text-xs text-muted-foreground">Needs attention</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Info Logs</CardTitle>
          <Info className="h-4 w-4 text-info" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-info">{metrics.infoLogs}</div>
          <p className="text-xs text-muted-foreground">Normal operations</p>
        </CardContent>
      </Card>
    </div>
  );
}
